import {
  BuildingOfficeIcon,
  CalendarIcon,
  BookOpenIcon,
  NewspaperIcon,
  UsersIcon,
  UserCircleIcon,
  QuestionMarkCircleIcon,
  GlobeAltIcon,
  ClipboardDocumentListIcon,
  EnvelopeIcon,
  DocumentIcon,
  DocumentArrowUpIcon,
  DocumentCheckIcon,
  InboxIcon,
  MagnifyingGlassIcon,
  FolderIcon,
  UserGroupIcon,
  ChartBarIcon,
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ExclamationTriangleIcon,
  UserIcon,
  BuildingOffice2Icon,
  DocumentTextIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';

export const iconMappings = {
  // Stats
  museums: BuildingOfficeIcon,
  events: CalendarIcon,
  resources: BookOpenIcon,
  news: NewspaperIcon,
  members: UserGroupIcon,
  institutions: BuildingOffice2Icon,
  chart: ChartBarIcon,

  // Quick Actions
  users: UsersIcon,
  user: UserIcon,
  userCircle: UserCircleIcon,
  calendar: CalendarIcon,
  help: QuestionMarkCircleIcon,
  globe: GlobeAltIcon,
  clipboard: ClipboardDocumentListIcon,
  envelope: EnvelopeIcon,

  // Documents
  document: DocumentIcon,
  documents: DocumentTextIcon,
  documentText: DocumentTextIcon,
  documentUpload: DocumentArrowUpIcon,
  documentCheck: DocumentCheckIcon,

  // Financial
  money: CurrencyDollarIcon,

  // Empty States
  inbox: InboxIcon,
  search: MagnifyingGlassIcon,
  folder: FolderIcon,
  userGroup: UserGroupIcon,
  building: BuildingOfficeIcon,

  // Status
  success: CheckCircleIcon,
  error: XCircleIcon,
  warning: ExclamationTriangleIcon,
  pending: ClockIcon,
} as const;

export type IconName = keyof typeof iconMappings;

export const getIcon = (name: IconName) => {
  return iconMappings[name];
};
